import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=92ad6a00&scoped=true"
import script from "./HistoryData.vue?vue&type=script&lang=js"
export * from "./HistoryData.vue?vue&type=script&lang=js"
import style0 from "./HistoryData.vue?vue&type=style&index=0&id=92ad6a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ad6a00",
  null
  
)

export default component.exports